import { Injectable, signal } from '@angular/core';
import { Sucursal } from '../api/sucursal.service';

@Injectable({
  providedIn: 'root'
})
export class CredentialsService {
  public credentials = signal<string | null>(null);
  public salaId = signal<string | null>(null);
  public sala = signal<string | null>(null);
  public sucursal = signal<Sucursal | null>(null);
}
